import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSnowshoeNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M.62 6.09l.82 12.75a4.548 4.548 0 002.41 3.75L6 23.74l2.14-1.14a4.545 4.545 0 002.42-3.75l.82-12.75A5.39 5.39 0 10.62 6.09zm1.45 1.58h1.7v3.663H2.3zm7.18 10.655H8v1.35h1.018A3.2 3.2 0 017.5 21.41l-.825.437V20h-1.35v1.847L4.49 21.4a3.2 3.2 0 01-1.508-1.725H4v-1.35H2.75l-.36-5.642h1.38v2.467a2.23 2.23 0 004.46 0v-2.467h1.38zM5.12 15.15v-3.59a.88.88 0 011.76 0v3.59a.88.88 0 01-1.76 0zm4.58-3.817H8.23V7.67h1.7zM6.675 1.771c.873.142 1.674.57 2.275 1.219a4.02 4.02 0 011.09 3.02l-.02.32H8.01a2.252 2.252 0 00-1.335-1.168zM6 6.41a.881.881 0 01.88.88v2.22a2.241 2.241 0 00-1.76 0V7.29A.881.881 0 016 6.41zM3.05 2.99a3.975 3.975 0 012.275-1.219v3.391A2.252 2.252 0 003.99 6.33H1.98l-.02-.32a4.006 4.006 0 011.09-3.02zm20.34 3.08a5.4 5.4 0 10-10.78 0l.82 12.76a4.575 4.575 0 002.42 3.76L18 23.74l2.14-1.14a4.549 4.549 0 002.43-3.76zm-5.35.31a.854.854 0 01.84.85v2.26a2.328 2.328 0 00-.92-.19 1.98 1.98 0 00-.84.18V7.23a.872.872 0 01.92-.85zm.84 5.12v3.68a.845.845 0 01-.84.84h-.08a.845.845 0 01-.84-.84V11.5a.867.867 0 01.92-.85.847.847 0 01.84.85zm-4.92-5.52a4 4 0 011.08-3.03 4.06 4.06 0 012.285-1.219v3.4a2.194 2.194 0 00-1.355 1.2h-1.99zm.11 1.69h1.7v3.645H14.3zm7.18 10.655H20v1.35h1.018a3.147 3.147 0 01-1.508 1.735l-.835.447V20h-1.35v1.847l-.835-.447a3.237 3.237 0 01-1.508-1.725H16v-1.35h-1.25l-.36-5.66h1.38v2.515a2.19 2.19 0 002.19 2.19h.08a2.19 2.19 0 002.19-2.19v-2.515h1.38zm.45-7.01h-1.47V7.67h1.7zm.32-4.985h-1.99a2.14 2.14 0 00-1.355-1.178V1.731A4.049 4.049 0 0122.04 5.99z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSnowshoeNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsSnowshoeNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSnowshoeNormalSmall;
